// Module
var code = "<% if (currentUser) { %>\n<input type=\"hidden\" name=\"visibility\" value=\"<%= visibility || \"\" %>\">\n<% } %>\n";
// Exports
export default code;